/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/fatherhood_variables.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpGrandpaVariables {
  constructor() {
    this.grandpa_vars = {};
  }

  buildGrandpaVariables(tree) {
    this.grandpa_vars = tree;
  }

  getVGrandpa(id) {
    return this.grandpa_vars[id];
  }
}

export default LpGrandpaVariables;



// WEBPACK FOOTER //
// ./src/app/indexes/fatherhood_variables.js